import React, { useEffect, useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Autocomplete, TextField, InputAdornment, MenuItem } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

const UpdateModal = ({ handleRefresh, apps, data }) => {
  const [agency] = useAgencyInfo()
  const AppService = useAppServices()

  const [openModal, setOpenModal] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [selectedApp, setSelectedApp] = useState(null)
  const [categoryType, setCategoryType] = useState('') // State for category type

  // Sync selected app from data
  useEffect(() => {
    if (openModal && data?.app_id && apps?.length > 0) {
      const matchedApp = apps.find((app) => app.app_id === data.app_id)
      setSelectedApp(matchedApp || null)
    }
  }, [openModal, apps, data])

  const handleModal = () => setOpenModal(true)

  const closeModal = () => {
    setOpenModal(false)
    setSelectedApp(null)
    setProcessing(false)
    setCategoryType('') // Reset category type on close

  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    const payload = {
      _id: data._id,
      app_id: selectedApp?.app_id,
      name: e.target.name.value,
      app_name: selectedApp?.name,
      type: categoryType, // Add category type to payload

    }

    const { response } = await AppService.AppsOnboarding.update_category({ payload })

    if (response) {
      setProcessing(false)
      closeModal()
      handleRefresh()
    } else {
      setProcessing(false)
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Update
      </MDButton>

      <MDModal open={openModal} onClose={closeModal}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Update Onboarding Category
            </MDTypography>



            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput
                label="Name"
                name="name"
                fullWidth
                defaultValue={data?.name}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <TextField
                select
                label="Select Type"
                value={categoryType}
                onChange={(e) => setCategoryType(e.target.value)}
                fullWidth
              >
                <MenuItem value="agency">Agency</MenuItem>
                <MenuItem value="location">Location</MenuItem>
              </TextField>
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeModal}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                disabled={processing}
              >
                {processing ? 'Updating...' : 'Update'}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default UpdateModal
